import React, { Component } from 'react'

export default class RandD extends Component {
    render() {
        return (

            <svg className={this.props.className} onClick={this.props.onClick} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4462 8.53516C17.3169 9.50079 19.3846 12.214 19.3846 15.4102C19.3846 19.4153 16.1378 22.662 12.1327 22.662C8.12763 22.662 4.88086 19.4153 4.88086 15.4102C4.88086 12.214 6.94854 9.50079 9.81923 8.53516" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round" />
                <path d="M14.4463 8.53705V2.96406C14.4463 2.79838 14.312 2.66406 14.1463 2.66406H10.1184C9.95267 2.66406 9.81836 2.79838 9.81836 2.96406V8.53705" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round" />
                <circle cx="8.95724" cy="16.3537" r="0.86154" fill="#001F82" />
                <circle cx="13.1366" cy="14.8905" r="1.46081" fill="#001F82" />
            </svg>
        )
    }
}
